import React from 'react';
import { Layout, routes, pageTypes, siteName, AdMobileAnchor, AdMobileBanner, AdLeaderboard, AdVideo } from 'gatsby-theme-apollo';
import GameContent from './content';
import PostPreviewCards from '../cards/post-preview-card';
import Section from '../layout/section';
import Footer from './footer';
import { sortPostsByDate } from '../../util/sort';
import EmptyState from '../status/empty-state';
import CTA from '../cta';
import { MyPosts } from '../content/my-content';

const PostHub = ({ location, pageContext }) => {
  const pageType = pageTypes.POST_HUB;
  const { posts, gameName } = pageContext;

  const pageTitle = `${gameName} | News and Guides | ${siteName}`;
  const crumbs = [{ text: `${gameName} Wiki`, url: routes.GameHub(gameName), hide: true }];
  const postSet = posts && sortPostsByDate(posts);

  return (
    <Layout location={location} title={pageTitle} pageType={pageType} gameName={gameName}>
      <AdMobileAnchor placementId={'gh-anchor-' + pageType +'-bottom'} anchorType='bottom' offset='47' />
      <GameContent header={`${gameName} News and Guides `} crumbs={crumbs} showTopShareBar>
        <AdMobileBanner placementId={"gh-mobilebanner-" + pageType + "-top"} />
        <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
        
        <MyPosts />
        <Section fullWidth title="Featured Guides">
          {postSet && postSet.length !== 0 ? (
            <PostPreviewCards postPreviews={postSet} />
          ) : (
            <EmptyState>
              No posts yet! Check back soon.
              <span role="img" aria-label="Thumbs Up">
                👍
              </span>
              <CTA campaignKey="WriteForUs" />
            </EmptyState>
          )}
        </Section>
        <Footer>
          <AdVideo placementId={'gh-video-' + pageType + '-floating'} />
        </Footer>
      </GameContent>
    </Layout>
  );
};

export default PostHub;
